import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  ModalDismissReasons,
  NgbDate,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { pipe } from 'rxjs';
import { ProductSatusService } from 'src/app/onelog/services/product-status.service';
import { ProductService } from 'src/app/onelog/services/product.service';
import { ProductListService } from 'src/app/onelog/services/product-list.service';
import { SachLoginService } from 'src/app/onelog/services/sach-login.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-video-licensing-page',
  templateUrl: './video-licensing-page.component.html',
  styleUrls: ['./video-licensing-page.component.css'],
})
export class VideoLicensingPageComponent {
  title = 'Onelog';
  @ViewChild('mymodal') mymodal!: ElementRef;
  Products: any = [];
  ProductStatusList: any = [];
  selectedProduct: any = [];
  selectedStatus: string = '';
  postData: any = [];
  TokenData: any = [];
  showLoader: boolean = false;
  model: any;
  date: any;
  updatedDate: any = [];
  responseData: any = [];
  source: string = 'videoLicensingPage';
  receivedDate: any;
  processingToastShow: boolean = false;
  successToastShow: boolean = false;
  closeResult: string;
  modalValue: string;
  apiURL = environment.sachWebURL;
  dropdownListProductType: any = [];
  dropdownSettingsProductType: IDropdownSettings = {};
  dropdownListBookType: any = [];
  dropdownSettingsBookType: IDropdownSettings = {};
  selectedProductType: any = [];
  selectedBookType: any = [];
  selectedproductId: string = '';

  constructor(
    private productService: ProductService,
    private productStatus: ProductSatusService,
    private sachLoginService: SachLoginService,
    private productListService: ProductListService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.loadProducts();
    //this.loadProductStatusList();
    //this.getSachToken();

    this.dropdownListProductType = [
      { item_id: 1, item_text: 'Course' },
      { item_id: 2, item_text: 'Audio Book' },
      { item_id: 3, item_text: 'Video' },
      { item_id: 4, item_text: 'Book' },
    ];
    this.dropdownSettingsProductType = {
      idField: 'item_id',
      textField: 'item_text',
    };

    this.dropdownListBookType = [
      { item_id: 1, item_text: 'Normal' },
      { item_id: 2, item_text: 'Mini' },
      { item_id: 3, item_text: 'Maxi' },
      { item_id: 4, item_text: 'Licensed' },
    ];

    this.dropdownSettingsBookType = {
      idField: 'item_id',
      textField: 'item_text',
    };
  }
  // Get employees list
  loadProducts(postData: any = []) {
    return this.productService.getProducts(postData).subscribe((data: {}) => {
      this.responseData = data;
      this.Products = this.responseData.data;
    });
  }

  loadProductStatusList() {
    return this.productStatus.getStatusList().subscribe((data: {}) => {
      this.ProductStatusList = data;
      this.showLoader = false;
    });
  }

  getCheckboxValues(event: Event, product: any) {
    if (this.selectedProduct.includes(product.id)) {
      this.selectedProduct.splice(this.selectedProduct.indexOf(product.id), 1);
    } else {
      this.selectedProduct.push(product.id);
    }
  }

  getSelectedStatus(event: Event) {
    console.log(this.selectedStatus);
  }

  onDateSelect(event: NgbDate) {
    console.log(event);
  }

  updateIepd(event: NgbDate) {
    this.receivedDate = event;
    this.open(this.mymodal);
  }

  submitStatus() {
    this.processingToastShow = true;
    this.postData = {
      source: this.source,
      productList: this.updatedDate,
      // 'productIds':this.selectedProduct
    };

    return this.productService
      .updateProductsDate(this.postData)
      .subscribe((data: {}) => {
        this.processingToastShow = false;
        this.successToastShow = true;
      });
  }

  searchProduct() {
    //Add API call to SACH search

    //Add API call to SACH search
    this.loadProducts({
      selectedBookType: this.selectedBookType,
      selectedProductType: this.selectedProductType,
      selectedproductId: this.selectedproductId,
    });
  }

  open(content: any): any {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
          return this.closeResult;
        },
        (reason) => {
          this.closeResult = `${this.getDismissReason(reason)}`;
          if (this.closeResult == 'save') {
            this.processRequest();
          }

          //return this.closeResult;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `${reason}`;
    }
  }

  processRequest() {
    this.updatedDate = this.productListService.updateData(this.receivedDate);
    this.submitStatus();
  }

  updateSelectedDropDown(event: Event) {
    console.log(event);
    const data: any = event;
    if (data.type == 'productType') {
      if (data.action == 'selected') {
        this.selectedProductType.push(data.item.item_text);
      } else {
        const index = this.selectedProductType.indexOf(data.item.item_text);
        this.selectedProductType.splice(index, 1);
      }
    }

    if (data.type == 'bookType') {
      if (data.action == 'selected') {
        this.selectedBookType.push(data.item.item_text);
      } else {
        const index = this.selectedBookType.indexOf(data.item.item_text);
        this.selectedBookType.splice(index, 1);
      }
    }
  }
}
